module.exports = __webpack_public_path__ + "img/banner_video_2.2c2c25ac.png";